const PRIVATE_LAN_HOST =
  /^(localhost|127\.0\.0\.1|192\.168\.\d{1,3}\.\d{1,3}|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/;

export const isCryptoAvailable = () => {
  if (typeof window === 'undefined') return true;
  return Boolean(window.crypto?.subtle && typeof window.crypto.getRandomValues === 'function');
};

export const isPrivateLanHost = hostname => PRIVATE_LAN_HOST.test(hostname || '');

export const getLanHttpsUrl = () => {
  if (typeof window === 'undefined') return '';
  const port = window.location.port || '3000';
  return `https://${window.location.hostname}:${port}`;
};

export const getCryptoUnavailableHint = () => {
  if (typeof window === 'undefined') return '';

  const { hostname, protocol } = window.location;

  if (protocol === 'http:' && isPrivateLanHost(hostname) && hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `Para testes na rede local, inicie o app com HTTPS e acesse ${getLanHttpsUrl()} (aceite o certificado no navegador).`;
  }

  return 'O login Microsoft exige HTTPS ou localhost. Verifique a URL e reinicie com HTTPS=true.';
};
